var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEditSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.56543 13.6282H14.4005",
    stroke: "#605BFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.9204 2.52986C9.43749 1.91186 10.367 1.82124 10.9979 2.32782C11.0328 2.35531 12.1534 3.22586 12.1534 3.22586C12.8464 3.64479 13.0617 4.5354 12.6333 5.21506C12.6106 5.25146 6.27502 13.1763 6.27502 13.1763C6.06424 13.4393 5.74428 13.5945 5.40233 13.5982L2.97608 13.6287L2.42941 11.3149C2.35283 10.9895 2.42941 10.6478 2.64019 10.3849L8.9204 2.52986Z",
    stroke: "#605BFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74805 4.00098L11.3829 6.79239",
    stroke: "#605BFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditSmall);
export default __webpack_public_path__ + "static/media/icon-edit-small.1573eba81f4be5eca9f9974a28fc8a93.svg";
export { ForwardRef as ReactComponent };